(ns app.front.view.property.dashboard.subs
  (:require [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-db ::toggle-new-property-visibility
  (fn [db _]
    (update-in db [::state :new-property-widget-visible?] not)))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::new-property-widget-visible?
  :<- [::state]
  :-> :new-property-widget-visible?)

(rf/reg-sub ::initial-data :-> ::initial-data)

(rf/reg-sub ::domain-groups
  :<- [::initial-data]
  (fn [initial-data _]
    (->> initial-data
         :authorized-dgs
         (sort-by :group/name))))

(rf/reg-sub ::multiple-domain-groups?
  :<- [::domain-groups]
  :-> #(-> % count (> 1)))

(rf/reg-sub ::default-domain-group
  :<- [::domain-groups]
  first)

(rf/reg-sub ::user-has-any-property-access?
  :<- [::domain-groups]
  #(-> % seq boolean))

(rf/reg-sub ::municipalities
  :<- [::domain-groups]
  (fn [dgs [_ dg]]
    (some->> dgs
             (filter #(-> % :db/id (= (:db/id dg))))
             first
             :municipalities)))

(rf/reg-sub ::authority-groups
  :<- [::domain-groups]
  (fn [dgs]
    (mapcat :authority-groups dgs)))

(rf/reg-sub ::authority-groups-with-periodic-inspections
  :<- [::authority-groups]
  (fn [ags]
    (filter #(-> % :group/features :group.feature/periodic-inspections) ags)))

(rf/reg-sub ::dashboard-access?
  :<- [:session/admin?]
  :<- [:session/authority-user?]
  :<- [::user-has-any-property-access?]
  (fn [[admin? authority? property-access?] _]
    (or admin?
        authority?
        property-access?)))

(rf/reg-event-fx ::fetch-temp-records
  (fn [_ [_ session-id]]
    {:fx [[:dispatch [:comm/command-monitored
                      {:command    :property-import/get-temp-records
                       :method     :get
                       :data       {:session-id session-id
                                    :from       0
                                    :size       100}
                       :on-success [::set-import-temp-records session-id]}]]]}))

(rf/reg-event-fx ::fetch-temp-records-if-empty
  (fn [{:keys [db]} [_ session-id]]
    (when (empty? (get-in db [::state ::import-sessions session-id ::records]))
      {:dispatch [::fetch-temp-records session-id]})))

(rf/reg-event-db ::set-import-temp-records
  (fn [db [_ session-id _ {:keys [hits]}]]
    (assoc-in db [::state ::import-sessions session-id ::records] hits)))

(rf/reg-event-db ::remove-import-session-data
  (fn [db [_ session-id]]
    (p/dissoc-in db [::state ::import-sessions session-id])))

(rf/reg-sub ::import-temp-records
  :<- [::state]
  (fn [state [_ session-id]]
    (->> (get-in state [::import-sessions session-id ::records])
         (sort-by :ordered/order))))

(rf/reg-event-fx ::fetch-duplicate-records
  (fn [_ [_ session-id]]
    {:fx [[:dispatch [:comm/command-monitored
                      {:command    :property-import/get-duplicate-records
                       :method     :get
                       :data       {:session-id session-id}
                       :on-success [::set-import-duplicate-records session-id]}]]]}))

(rf/reg-event-fx ::gis-fetch-finished
  (fn [_ [_ session-id]]
    {:fx [[:dispatch [::fetch-temp-records-if-empty session-id]]
          [:dispatch [::fetch-duplicate-records session-id]]]}))

(rf/reg-event-db ::set-import-duplicate-records
  (fn [db [_ session-id _ duplicates]]
    (assoc-in db [::state ::import-sessions session-id ::duplicates] duplicates)))

(rf/reg-sub ::import-duplicate-records
  :<- [::state]
  (fn [state [_ session-id]]
    (get-in state [::import-sessions session-id ::duplicates])))

(rf/reg-event-db ::set-imported-properties
  (fn [db [_ session-id _ {:keys [hits]}]]
    (assoc-in db [::state ::import-sessions session-id ::properties] hits)))

(rf/reg-sub ::imported-properties
  :<- [::state]
  (fn [state [_ session-id]]
    (get-in state [::import-sessions session-id ::properties])))
